export default __webpack_public_path__ + "static/media/bg-img.8fd5abc4.png";